function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.001 2C6.48098 2 2.00098 6.48 2.00098 12C2.00098 17.52 6.48098 22 12.001 22C17.521 22 22.001 17.52 22.001 12C22.001 6.48 17.521 2 12.001 2ZM7.07098 18.28C7.50098 17.38 10.121 16.5 12.001 16.5C13.881 16.5 16.511 17.38 16.931 18.28C15.571 19.36 13.861 20 12.001 20C10.141 20 8.43098 19.36 7.07098 18.28ZM18.361 16.83C16.931 15.09 13.461 14.5 12.001 14.5C10.541 14.5 7.07098 15.09 5.64098 16.83C4.62098 15.49 4.00098 13.82 4.00098 12C4.00098 7.59 7.59098 4 12.001 4C16.411 4 20.001 7.59 20.001 12C20.001 13.82 19.381 15.49 18.361 16.83ZM12.001 6C10.061 6 8.50098 7.56 8.50098 9.5C8.50098 11.44 10.061 13 12.001 13C13.941 13 15.501 11.44 15.501 9.5C15.501 7.56 13.941 6 12.001 6ZM12.001 11C11.171 11 10.501 10.33 10.501 9.5C10.501 8.67 11.171 8 12.001 8C12.831 8 13.501 8.67 13.501 9.5C13.501 10.33 12.831 11 12.001 11Z",
  fill: "#201858"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.554688,
  width: 24.5538,
  height: 24,
  fill: "white"
})));

var SvgAccount = function SvgAccount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account.0d1629a5.svg";
export { ForwardRef as ReactComponent };